import { call, put, takeLatest } from 'redux-saga/effects';
import { get } from 'lodash';
import { getCastWorksListAction, getCastWorksRolesListAction, getRolesAction } from './actions';
// eslint-disable-next-line import/named
import * as API from '../../utils/API';
import { WORK_ROLES } from '../../constants/endpointConstants';
import { getListSaga } from '../App/saga';
import { performancesAggregationTypes } from '../../constants/consts';

export function* fetchCastWorksList({ payload }) {
  try {
    const response = yield call(API.getWorks, payload.params, payload.pagination || { limit: 10 });
    yield put(getCastWorksListAction.success(get(response, 'data.data')));
  } catch (err) {
    yield put(getCastWorksListAction.failure(err.message));
  } finally {
    yield put(getCastWorksListAction.fulfill());
  }
}

export function* getRolesSaga({ payload }) {
  try {
    const { castsListParams } = payload;
    const { workRoleAgg, workAgg } = performancesAggregationTypes;

    const workRoles = yield call(
      API.getAggregations,
      false,
      {
        aggregation_type: workRoleAgg,
        work_id: get(castsListParams, workAgg, []).join(','),
      },
      { limit: 100 },
    );
    const workRoleIds = get(workRoles, 'data.data', []).map(role => role?.id);
    if (workRoleIds.length > 0) {
      yield call(getListSaga, {
        payload: {
          endpoint: WORK_ROLES,
          sagaRoutine: getCastWorksRolesListAction,
          params: {
            queryParams: {
              id: workRoleIds.join(','),
            },
            pagination: { limit: 100 },
          },
        },
      });
    }
    yield put(getRolesAction.success());
  } catch (err) {
    yield put(getRolesAction.failure(err.message));
  } finally {
    yield put(getRolesAction.fulfill());
  }
}

export default function* castSaga() {
  yield takeLatest(getCastWorksListAction.TRIGGER, fetchCastWorksList);
  yield takeLatest(getRolesAction.TRIGGER, getRolesSaga);
}
